// Office.js adapter. The ONLY file that touches the Office host API.
// Outside Outlook (standalone web), every function is a safe no-op so the same
// bundle runs anywhere.

declare const Office: any; // typed via @types/office-js; declared for no-op path

export function isOutlook(): boolean {
  try {
    return typeof Office !== 'undefined' && !!Office?.context?.mailbox?.item;
  } catch {
    return false;
  }
}

export interface OpenEmail {
  subject: string;
  from: string;
  body: string;
}

// Reads the currently open email (read mode). Resolves null outside Outlook.
export function readOpenEmail(): Promise<OpenEmail | null> {
  return new Promise((resolve) => {
    if (!isOutlook()) return resolve(null);
    try {
      const item = Office.context.mailbox.item;
      const subject: string = item.subject || '';
      const from: string = item.from?.emailAddress || item.sender?.emailAddress || '';
      item.body.getAsync('text', (result: any) => {
        if (result.status === 'succeeded') {
          resolve({ subject, from, body: result.value || '' });
        } else {
          resolve({ subject, from, body: '' });
        }
      });
    } catch {
      resolve(null);
    }
  });
}

// Builds a "seed" string for Concept mode from the open email.
export function emailToSeed(email: OpenEmail): string {
  return [
    email.subject ? `Onderwerp: ${email.subject}` : '',
    email.from ? `Van: ${email.from}` : '',
    '',
    email.body,
  ]
    .filter(Boolean)
    .join('\n')
    .trim();
}
